// Named export by convention — thunks are imported by name (and more land here later).
/* eslint-disable import/prefer-default-export */
import { createAsyncThunk } from '@reduxjs/toolkit';
import apiClient from 'src/helpers/apiClient';

export const fetchProfileRewardsOverview = createAsyncThunk(
  'profileRewards/fetchOverview',
  async ({ orgId }: { orgId: string }, { rejectWithValue }) => {
    try {
      const response = await (
        await apiClient.getProfileRewardsApi()
      ).profileRewardsApiGetProfileRewards({ orgId });
      return response.data;
    } catch (err: any) {
      return rejectWithValue(err?.response?.data);
    }
  },
);
